
    const data = {"name":"src/core/icons/chat-alert","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 3c5.5 0 10 3.58 10 8s-4.5 8-10 8c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.13 2 11c0-4.42 4.5-8 10-8m-1 11v2h2v-2h-2m0-2h2V6h-2v6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            